export default __webpack_public_path__ + "static/uk-c8faa5abfde6e69b8582a4797a165b2f.png";